<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getProperties"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          class="ml-2"
          :to="{ name: 'properties-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-md-1">Occupied</div>
        <div class="col-md-3">Title</div>
        <div class="col-md-3">Collections</div>
        <div class="col-md-3">Address</div>
        <div class="col-md-2 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-1 my-auto">
          <i
            class="lni lni-checkmark text-success"
            v-if="slotProps.item.is_occupied"
          ></i>
          <i
            class="lni lni-cross-circle text-danger"
            v-if="!slotProps.item.is_occupied"
          ></i>
        </div>

        <div class="col-md-3 my-auto">
          <p class="m-0">{{ slotProps.item.title }}</p>
        </div>

        <div class="col-md-3 my-auto">
          <b-badge
            variant="info"
            v-for="c in slotProps.item.collections"
            :key="c.id"
            class="m-0"
            >{{ c.title }}</b-badge
          >
        </div>

        <div class="col-md-3 my-auto">
          <p class="m-0">
            {{ slotProps.item.address }},{{ slotProps.item.city }}
          </p>
        </div>

        <div class="col-md-2 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="view"
            :to="{
              name: 'properties-show',
              params: { id: slotProps.item.id },
            }"
            class="text-info table-action-icon"
          >
            <i class="lni lni-search-alt"></i>
          </router-link>
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'properties' })"
      :lazy="true"
    >
      <router-view @propertyCreated="propertyCreated()"></router-view>
    </b-modal>

    <b-alert variant="info" show>
      <b-media>
        <template #aside>
          <i class="lni lni-bulb font-size-26"></i>
        </template>
        <ul>
          <li>A property is a single leasible unit</li>
          <li>Every flat in a building will be its own property</li>
          <li>Units / Properties can be grouped by using collections</li>
        </ul>
      </b-media>
    </b-alert>
  </div>
</template>

<script>
import propertyRepo from "@/api/repos/propertyRepo";
import collectionRepo from "@/api/repos/collectionRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      collections: [],
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "description", label: "Description Asc", order: "asc" },
      sortOptions: [
        { column: "description", label: "Description Asc", order: "asc" },
        { column: "description", label: "Description Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getProperties({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      search: "",
    });

    this.getCollections();
  },
  methods: {
    async getCollections() {
      try {
        let { data } = await collectionRepo.collections(
          1,
          100,
          "title",
          "asc",
          "",
          null
        );
        this.collections = data.collections.data;

        this.filterOptions = [];

        this.collections.forEach((x) => {
          this.filterOptions.push({
            column: "collections.title",
            value: x.title,
            label: x.title,
          });
        });
      } catch (ex) {
        console.log(ex);
      }
    },
    async deleteCollection(id) {
      this.isBusy = true;
      try {
        await propertyRepo.delete(id);
        this.items = this.items.filter((item) => item.id !== id);
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the property.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteCollection(id) : false))
        .catch((error) => console.log(error));
    },
    async getProperties(e) {
      this.isLoad = true;
      try {
        let { data } = await propertyRepo.properties(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.properties.data;
        this.totalRows = data.properties.total;
        this.page = data.properties.current_page;
        this.fromRow = data.properties.from;
        this.toRow = data.properties.to;
        this.lastPage = data.properties.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    propertyCreated() {
      this.$bvToast.toast("Collection Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getProperties({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 10,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
